import { useEffect } from "react";
import { useSelector } from "react-redux";
import { retrieveLatestArticles } from "../../../redux/slice/latest-articles-slice";
import { RootState, useAppDispatch } from "../../../redux/store";

import Card from "../../../widgets/cards";
import Constants from "../../../data/constants";
import { baseURL } from "../../../http-common";

const TrendingNews = () => {
  // TODO: Find a way to use same API using just one reducer if possible
  // otherwise just create a separate service.
  // Conflicts with regulatory-focus-articles.tsx
  // to temporarily fix, change the numberOfArticles then hit save
  const { trendingNewsData , loading, error } = useSelector(
    (state: RootState) => state.latestArticles
  );

  const dispatch = useAppDispatch();
  const numberOfArticles = 1;

  useEffect(() => {
    dispatch(retrieveLatestArticles(numberOfArticles));
  }, [dispatch]);

  var articles = trendingNewsData?.map((item) => {
    return {
      date: item.articleReleaseDate,
      author: item.author,
      icon: "",
      category: "Trending News",
      title: item.articleName,
      description: item.articleTeaserText,
      img: item.articleTeaserImage, // substring to remove the extra '~' at the beginning
      alt: item.articleName,
      showHomePage: true,
      articleURL: item.articleUrl
    };
    
  });
  var latestArticles = [
    {
      title: "Trending News",
      link: "/news-and-articles/",
      article: articles,
    },
  ];

  return <Card cardData={latestArticles} />;
};

export default TrendingNews;
